export const SAVE = 'step2.SAVE';
export const VALUE_CHANGED = 'step2.VALUE_CHANGED';
export const LOAD = 'step2.VALUE_LOAD';
export const LOAD_CLIENT_INFO = 'step2.LOAD_CLIENT_INFO';
export const RESET = 'step2.RESET';
export const RESET_OTHER_INSURANCE_STATE = 'step2.RESET_OTHER_INSURANCE_STATE';
export const RESET_GIVE_PERMISSION_STATE = 'step2.RESET_GIVE_PERMISSION_STATE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step2/constants.js